/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


$(document).on("click", ".th_pb_add_to_cart.btn.button", function(e){
  e.preventDefault();
});

(function () {
  window.onpageshow = function() {
    if (window.theme.showPageTransition) {
      var pageTransition = document.querySelector('.PageTransition');

      if (pageTransition) {
        pageTransition.style.visibility = 'visible';
        pageTransition.style.opacity = '0';
      }
    }
    // When the page is loaded from the cache, we have to reload the cart content
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
  };
})();

$(document).on('click', '.xlose_bold', function(){
  $(".bold-ro__tooltip").hide();
}); 
$(document).on('click', '.ProductForm__Option', function(){
  if (BOLD && BOLD.recurring_orders && BOLD.recurring_orders.app && BOLD.recurring_orders.app.ee &&
      typeof BOLD.recurring_orders.app.ee.emit === 'function'){
    BOLD.recurring_orders.app.ee.emit('variant_changed');
  }
}); 